import React from 'react';

import isArchived from 'archive/isArchived';
import FileBrowserUtil from 'file-browser/FileBrowserUtil';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableItem} from 'search/SearchConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {ReactionGraphQL} from '../../../../graphql-fragments/chemistry/__generated/ReactionGraphQL';

interface ReactionSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  item: ListableItem;
  openResult: (item: ListableItem) => void;
  isChild: boolean;
}

export default function ReactionSidepanelItem(props: ReactionSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, item, isChild} = props;
  const reaction = item as ReactionGraphQL;
  const {prefix, date} = FileBrowserUtil.getResultDate(reaction, {fuzzy: true, compact: isCompact});
  const subtitle = isCompact ? undefined : `${prefix}${date}`;
  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(item)}
      icon={<BenchlingIcon icon="reaction-vessel" />}
      isCompact={isCompact}
      onClick={() => {
        props.openResult(item);
      }}
      parties={[{...reaction.creator, avatar_url: reaction.creator.avatarUrl!}]}
      subTitle={subtitle}
      title={{
        text: item.name,
        node: <span>{item.name}</span>,
      }}
      tooltipText=""
      isExpandable={false}
      isChild={isChild}
    />
  );
}
